import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchStaticPages } from "../../store/actions/staticPages";

import GoogleSocialAuth from "./GoogleAuth";
import AppleSocialAuth from "./AppleAuth";
import EmailAuth from "./EmailAuth";
import ProductHeader from "../ProductDetails/ProductHeader";
import { CircularProgress } from "@material-ui/core";

import Profile from "./Profile";
import Unregistered from "./Unregistered";
import ActionButton from "../ActionButton";
import {
  canUseSocialAuth,
  isOrderPassEnabled,
  shouldStartWithOrderPassContact,
} from "../../Helpers/orderPass";

class index extends Component {
  componentDidMount = () => {
    if (
      !canUseSocialAuth(this.props.settings) &&
      !isOrderPassEnabled(this.props.settings) &&
      this.props.pages.findIndex((page) => page.placement == 1) == -1
    )
      this.props.history.replace("/");

    if (!this.props.pages.length && this.props.settings.enable_static_pages)
      this.props.fetchStaticPages();
  };

  state = {
    tabState: 0,
  };

  changeTabState = (state) => {
    this.setState({
      tabState: state,
    });
  };

  shouldStartWithOrderPassContact = () =>
    shouldStartWithOrderPassContact(
      this.props.settings,
      this.props.customerContact,
      this.props.orderPassVerifiedPhone,
      this.props.orderPassGuestBypassPhone,
    );

  handleDialogContinue = () => {
    if (this.shouldStartWithOrderPassContact()) {
      this.props.history.push("/checkout/details");
      return;
    }
    this.props.history.push("/cart");
  };

  shouldShowCheckoutButton = () => {
    const { settings } = this.props;
    if (this.shouldStartWithOrderPassContact()) {
      return true;
    }
    if (settings.is_branch_based_ordering && !this.props.branch) return false;
    if (
      !settings.is_branch_based_ordering &&
      !this.props.address?.area &&
      !this.props.address?.pickupArea
    )
      return false;
    return true;
  };

  render() {
    const {
      language,
      auth,
      cart,
      cart_items,
      promo_items,
      customTexts,
      settings,
    } = this.props;
    const totalCartLength = cart_items.length + promo_items.length;
    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <div className="free-space-70-white"></div>
        <ProductHeader onBack={() => this.props.history.replace("/")} />
        {auth.loading || (localStorage.getItem("stoken") && !auth.user) ? (
          <CircularProgress size={32} />
        ) : (
          <>
            {!auth.user ? (
              <Unregistered
                tabState={this.state.tabState}
                setTabState={this.changeTabState}
              />
            ) : (
              <Profile
                tabState={this.state.tabState}
                setTabState={this.changeTabState}
              />
            )}

            {/* {this.props.store.settings.enable_social_auth &&
              this.props.store.settings.enable_social_auth_staff &&
              this.state.tabState == 0 && (
                <div
                  style={{
                    marginTop: 32,
                    marginBottom: 100,
                  }}
                >
                  {(!auth.user ||
                    (auth.user && auth.user.provider === "email")) && (
                    <EmailAuth
                      history={this.props.history}
                      language={language}
                    />
                  )}

                  {(!auth.user ||
                    (auth.user && auth.user.provider === "google")) && (
                    <GoogleSocialAuth
                      history={this.props.history}
                      language={language}
                    />
                  )}
                  {(!auth.user ||
                    (auth.user && auth.user.provider === "apple")) && (
                    <AppleSocialAuth
                      history={this.props.history}
                      language={language}
                    />
                  )}
                </div>
              )} */}
          </>
        )}
        <div className="free-space-70-white"></div>
        {totalCartLength > 0 && (
          <div>
            <ActionButton
              action={
                this.shouldShowCheckoutButton()
                  ? language == "english"
                    ? customTexts.review_order
                    : customTexts.review_order_ar
                  : language === "arabic"
                    ? customTexts.select_location_ar
                    : customTexts.select_location
              }
              onClick={() => {
                if (this.shouldShowCheckoutButton())
                  this.handleDialogContinue();
                else this.props.history.push("/select/branch");
              }}
              total={
                this.shouldShowCheckoutButton()
                  ? cart.price.toFixed(settings.currency_decimals)
                  : undefined
              }
              quantity={
                this.shouldShowCheckoutButton()
                  ? totalCartLength > 0
                    ? totalCartLength
                    : null
                  : undefined
              }
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    cart_items: state.cart.cart,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    address: state.customers?.address,
    customerContact: state.customers?.customerContact,
    orderPassVerifiedPhone: state.customers?.orderPassVerifiedPhone,
    orderPassGuestBypassPhone: state.customers?.orderPassGuestBypassPhone,
    pages: state.staticPages.pages,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStaticPages: () => dispatch(fetchStaticPages()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
